import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppContext, SET_ZONE } from '../context/AppContext';
import StateMap from '../components/StateMap';
import CountryMap from '../components/region-maps/CountryMap';
import PacificMap from '../components/region-maps/regions/PacificMap';
import RockyMountainMap from '../components/region-maps/regions/RockyMountainMap';
import MidwestMap from '../components/region-maps/regions/MidwestMap';
import SouthwestMap from '../components/region-maps/regions/SouthwestMap';
import NortheastMap from '../components/region-maps/regions/NortheastMap';
import SoutheastMap from '../components/region-maps/regions/SoutheastMap';
import { Constants, colors, fontSize } from '../constants';
import '../css/header.css';
import '../css/body.css';
import '../css/animations.css';


const mobileMapContainerStyle = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '10px',
  overflow: 'hidden',
  backgroundColor: colors.mobileBackground,
  minHeight: 0,
  maxHeight: '100%',
  width: '100%',
};


const ZoneSelectorMobile = ({
  selectedRegion,
  setSelectedRegion,
  selectedState,
  selectedZone,
  setSelectedState,
  setSelectedZone,
  handleSelectRegion,
  handleSelectState,
  handleBackToRegion,
  handleBackToCountry,
  handleSelectZone,
  currentAnimation,
  setCurrentAnimation
}) => {
  const navigate = useNavigate();
  const { state, dispatch } = useAppContext();

  // Navigate to the previous screen
  const handleBack = () => {
    console.log(state);
    navigate('/');
  };

  const renderMap = () => {
    if (!selectedRegion) {
      return <CountryMap onRegionClick={handleSelectRegion} />;
    }

    switch (selectedRegion) {
      case 'pacific':
        return <PacificMap onStateClick={handleSelectState} />;
      case 'rocky-mountains':
        return <RockyMountainMap onStateClick={handleSelectState} />;
      case 'midwest':
        return <MidwestMap onStateClick={handleSelectState} />;
      case 'southwest':
        return <SouthwestMap onStateClick={handleSelectState} />;
      case 'northeast':
        return <NortheastMap onStateClick={handleSelectState} />;
      case 'southeast':
        return <SoutheastMap onStateClick={handleSelectState} />;
      default:
        return null;
    }
  };

  const renderStateOrZoneMap = () => {
    // Simple container that forces maps to fit
    const containerStyle = {
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'hidden',
      backgroundColor: colors.mobileBackground,
      //marginTop: '100px',
      //paddingBottom: '150px'

    };

    if (selectedState) {
      return (
        <div style={containerStyle}>
          <StateMap
            stateId={selectedState}
            onZoneClick={handleSelectZone}
            selectedZone={selectedZone}
          />
        </div>
      );
    }
    return (
      <div style={containerStyle}>
        {renderMap()}
      </div>
    );
  };

  const renderBackToHomeButton = () => {
    return (
      <button 
        onClick={handleBack}
        style={{
          position: 'absolute',
          bottom: '150px',
          left: '50%',
          transform: 'translateX(-50%)',
          zIndex: 10,
          backgroundColor: colors.buttonColor,
          color: colors.white,
          border: 'none',
          borderRadius: Constants.borderRadius.medium,
          padding: '5px 20px',
          fontSize: Constants.fontSize.xl,
          fontWeight: 'bold',
          cursor: 'pointer',
          minHeight: '50px',
          minWidth: '170px',
        }}
      >
        Back To Home
      </button>
    )
  }

  const renderBackButton = () => {
    const onClick = selectedState ? handleBackToRegion : handleBackToCountry;
    return selectedRegion ? (
      <button 
        onClick={onClick} 
        style={{
          position: 'absolute',
          top: '20px',
          left: '20px',
          zIndex: 10,
          backgroundColor: colors.buttonColor,
          color: colors.white,
          border: 'none',
          borderRadius: Constants.borderRadius.medium,
          padding: '5px 20px',
          fontSize: Constants.fontSize.lg,
          fontWeight: 'bold',
          cursor: 'pointer',
          minHeight: '44px',
          minWidth: '80px',
        }}
      >
        Back
      </button>
    ) : null;
  }

  return (
    <div style={{ 
      height: '100vh', 
      width: '100vw',
      display: 'flex', 
      flexDirection: 'column',
      backgroundColor: colors.mobileBackground,
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      overflow: 'hidden'
    }}>
      <header style={{ 
        textAlign: 'center', 
        padding: '10px',
        backgroundColor: colors.backgroundLight,
        height: '120px',
        borderBottom: `12px solid ${colors.white}`,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        alignItems: 'center',
        position: 'relative'
      }}>
        <h1 style={{ 
          margin: '0', 
          fontSize: fontSize.xxxl,
        }}>
          {`Choose your Region`}
        </h1>
      </header>
      
      <div style={{
        ...mobileMapContainerStyle,
        backgroundColor: colors.mobileBackground,
        flex: 1,
        minHeight: 0,
        position: 'relative'
      }}>
        <div style={{ 
          width: '100%', 
          height: '100%', // calc(100vh - 120px - 100px)
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          backgroundColor: colors.mobileBackground,
          marginBottom: '100px',
          //overflow: 'hidden',
          position: 'relative',
          //padding: '20px'
        }}>
          <div className={`map-body-container ${currentAnimation}`}>
            {renderStateOrZoneMap()}
          </div>
        </div>
        {renderBackButton()}
        {renderBackToHomeButton()}
      </div>
    </div>
  );
};

export default ZoneSelectorMobile;
